import store from '../../store';

export default function getMeshName(id) {
  const allMeshNames = store.getters.getMeshNames
  const meshName = allMeshNames.find(mesh => mesh.id === id)
  return meshName?.meshName
}